import React, { useContext, useEffect, useState } from "react";
import { StyleSheet, Text, View, TouchableOpacity } from "react-native";

import ReflectionContext from "../ReflectionContext";
import Icons from "../../common/icons/index";
import MoodsHelper, { getTextColorByMood } from "../../common/mood/MoodsHelper";

import IntervalPicker from "../../common/interval-dropdown/IntervalPicker";
import AppTheme from "../../AppTheme";
import hoursStyles from "../list/hoursStyles";
import Utils from "../../../../helpers/utils";

import TABLE_DATE_FORMATS from "./formats";

export default function ReflectionHeaderTable({
  days = [],
  timeline = [],
  timeUnit,
  showBackIcon,
  travelInTime = () => {},
  onPickerValueChanged = () => {},
}) {
  const { onHoursSelected, showTutorials } = useContext(ReflectionContext) || {};
  const [daysList, setDaysList] = useState([]);

  useEffect(() => {
    initIntervals(timeUnit);
  }, [days, timeUnit]);

  const initIntervals = (tu) => {
    const format = TABLE_DATE_FORMATS[tu]?.tableColumnFormat;
    if (!format || !days) return [];

    const intervals = days.map((d) => {
      return {
        ...d,
        label: Utils.formatDateByTimeUnit({
          date: d.day,
          timeUnit: tu,
          format,
        }),
      };
    });

    setDaysList(intervals.reverse());
  };

  const onDaySelected = (day, dayIndex) => {
    if (showTutorials) return;

    onHoursSelected(
      {
        item_type: "time",
        item_id: "",
        timeline: timeline,
      },
      day,
      dayIndex,
    );
  };

  return (
    <View style={styles.container}>
      <IntervalPicker
        defaultValue={timeUnit}
        onPickerValueChanged={onPickerValueChanged}
        textStyle={{
          backgroundColor: "#F4F6FA",
          borderTopLeftRadius: 4,
          borderTopRightRadius: 4,
          borderBottomLeftRadius: 4,
          borderBottomRightRadius: 4,
          borderWidth: 0,
        }}
      />

      <View style={styles.intervals}>
        <View style={styles.arrowsContainer}>
          <Icons.ArrowLeft
            fillColor={AppTheme.iconBlack}
            onPress={() => travelInTime(-1)}
          />

          <Icons.ArrowRight
            style={{ opacity: showBackIcon ? 1 : 0.5 }}
            fillColor={AppTheme.iconBlack}
            onPress={() => travelInTime(1, showBackIcon)}
          />
        </View>

        {/* Intervals */}

        <View style={hoursStyles.daysContainer}>
          {daysList.map((day, dayIndex) => (
            <TouchableOpacity
              key={days.length - 1 - dayIndex}
              onPress={() => onDaySelected(day, days.length - 1 - dayIndex)}
              style={[hoursStyles.tile]}
            >
              <View
                style={[
                  day.gem &&
                    day.gem.mood &&
                    MoodsHelper.geReflectionGemStyle(day.gem.mood),
                ]}
              >
                <Text
                  style={[
                    hoursStyles.dayText,
                    { color: getTextColorByMood(day?.gem?.mood) || "#FFF" },
                  ]}
                >
                  {day.label}
                </Text>
                {/* {day.in_progress && <View style={styles.dot} />} */}
              </View>
            </TouchableOpacity>
          ))}
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    display: "flex",
    justifyContent: "space-evenly",
    alignItems: "center",
    flexDirection: "row",
    zIndex: 2,
    backgroundColor: AppTheme.headerBg,
    paddingLeft: 16,
    paddingRight: 12,
    height: 40,
  },
  intervals: {
    position: "relative",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    flexDirection: "row",
    marginLeft: 20,
    flex: 1,
  },
  arrowsContainer: {
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    flexDirection: "row",
    marginRight: 4,
  },
  dot: {
    width: 6,
    height: 6,
    borderRadius: 3,
    position: "absolute",
    bottom: 9,
    left: "45%",
    backgroundColor: "red",
  },
  gemStyles: {
    height: 35,
    width: 35,
    borderRadius: 35,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: AppTheme.title,
  },
});
